var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlassSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2694 9.88563L12.9462 12.5619L12.0619 13.4462L9.38563 10.7694C8.38984 11.5676 7.15125 12.0018 5.875 12C2.77 12 0.25 9.48 0.25 6.375C0.25 3.27 2.77 0.75 5.875 0.75C8.98 0.75 11.5 3.27 11.5 6.375C11.5018 7.65125 11.0676 8.88984 10.2694 9.88563ZM9.01562 9.42188C9.80882 8.60618 10.2518 7.51277 10.25 6.375C10.25 3.9575 8.29187 2 5.875 2C3.4575 2 1.5 3.9575 1.5 6.375C1.5 8.79187 3.4575 10.75 5.875 10.75C7.01277 10.7518 8.10618 10.3088 8.92188 9.51562L9.01562 9.42188Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassSm);
export default __webpack_public_path__ + "static/media/magnifying-glass-sm.40cc5698086a61652739d4bddb80acb0.svg";
export { ForwardRef as ReactComponent };